import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as SettingsIcon } from '../img/setting_icon.svg';

const THEME_STORAGE_KEY = 'theme';

export function switchTheme(themeName) {
  const id = 'theme-css';
  const existingLink = document.getElementById(id);
  if (existingLink) existingLink.remove();

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `/css/${themeName}/${themeName}_common.css`;
  document.head.appendChild(link);

  localStorage.setItem(THEME_STORAGE_KEY, themeName);
}

export function loadInitialTheme() {
  const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  if (savedTheme) switchTheme(savedTheme);
}

export function removeTheme() {
  const existingLink = document.getElementById('theme-css');
  if (existingLink) existingLink.remove();
  localStorage.removeItem('theme');
}

function SettingsPopup() {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => setIsOpen(prev => !prev);
  const handleThemeChange = (themeName) => {
    switchTheme(themeName);
    setIsOpen(false);
  };

  // Handle button Click
  const handleDefaultButton = () => {
    const url = `/`;
    window.location.href = url;
  };
  const handleWinnerButton = () => {
    const url = `/static-pages/winner-page`;
    window.location.href = url;
  };

  return (
    <>
      {/* <div className="theme-icon-container">
        <Link onClick={togglePopup}>
          <SettingsIcon className="theme-icon" />
        </Link>
      </div> */}

      <div
        className={`theme-backdrop ${isOpen ? '' : 'hidden'}`}
        onClick={() => setIsOpen(false)}
      />

      <div
        className="slider-panel"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
          visibility: isOpen ? 'visible' : 'hidden',
          pointerEvents: isOpen ? 'auto' : 'none',
        }}
      >
        <div className="d-flex justify-content-end">
          <button className="btn-close" onClick={() => setIsOpen(false)} />
        </div>

        <div className='p-2 p-lg-5  pb-2 pb-lg-0'>
          <h4 className="fw-semibold mt-3">Choose Theme</h4>

          <div className="container mt-4">
            <div className="row row-cols-1 g-3 justify-content-center">
              {["A", "B", "C", "D", "E"].map(company => (
                <div className="col" key={company}>
                  <button
                    className={`btn com-btns com-${company}-btn w-100`}
                    onClick={() => handleThemeChange(`Company_${company}`)}
                  >
                    Theme_{company}
                  </button>
                </div>
              ))}
            </div>

            <button
              className="btn com-btns default-theme-btn mt-3 w-100"
              onClick={() => {
                removeTheme();
                setIsOpen(false);
              }}
            >
              Default Theme
            </button>
          </div>
        </div>

        <div className='p-2 p-lg-5 pb-2 pb-lg-2'>
          <h4 className="fw-semibold mt-3">Choose Page</h4>

          <div className="container mt-4">
            <div className='d-flex gap-2'>
              <button
                className="btn com-btns page-btns mt-3 w-100"
                onClick={handleDefaultButton}
              >
                Default Page
              </button>

              <button
                className="btn com-btns page-btns mt-3 w-100"
                onClick={handleWinnerButton}
              >
                Winner Page
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default SettingsPopup;